import { render, staticRenderFns } from "./HonorSystem_System.vue?vue&type=template&id=65b036c4&"
import script from "./HonorSystem_System.vue?vue&type=script&lang=js&"
export * from "./HonorSystem_System.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports